// Currency Definitions
// -----------------------------------------------
const CurrencyDefinitions = [
  {
    symbol: '$',
    label: 'US Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'usd',
    name_plural: 'US dollars'
  },
  {
    symbol: 'CA$',
    label: 'Canadian Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'cad',
    name_plural: 'Canadian dollars'
  },
  {
    symbol: '€',
    label: 'Euro',
    symbol_native: '€',
    decimal_digits: 2,
    rounding: 0,
    value: 'eur',
    name_plural: 'euros'
  },
  {
    symbol: 'AU$',
    label: 'Australian Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'aud',
    name_plural: 'Australian dollars'
  },
  {
    symbol: 'R$',
    label: 'Brazilian Real',
    symbol_native: 'R$',
    decimal_digits: 2,
    rounding: 0,
    value: 'brl',
    name_plural: 'Brazilian reals'
  },
  {
    symbol: 'CHF',
    label: 'Swiss Franc',
    symbol_native: 'CHF',
    decimal_digits: 2,
    rounding: 0.05,
    value: 'chf',
    name_plural: 'Swiss francs'
  },
  {
    symbol: 'CN¥',
    label: 'Chinese Yuan',
    symbol_native: 'CN¥',
    decimal_digits: 2,
    rounding: 0,
    value: 'cny',
    name_plural: 'Chinese yuan'
  },
  {
    symbol: '£',
    label: 'British Pound Sterling',
    symbol_native: '£',
    decimal_digits: 2,
    rounding: 0,
    value: 'gbp',
    name_plural: 'British pounds sterling'
  },
  {
    symbol: 'HK$',
    label: 'Hong Kong Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'hkd',
    name_plural: 'Hong Kong dollars'
  },
  {
    symbol: 'Rs',
    label: 'Indian Rupee',
    symbol_native: 'টকা',
    decimal_digits: 2,
    rounding: 0,
    value: 'inr',
    name_plural: 'Indian rupees'
  },
  {
    symbol: '¥',
    label: 'Japanese Yen',
    symbol_native: '￥',
    decimal_digits: 0,
    rounding: 0,
    value: 'jpy',
    name_plural: 'Japanese yen'
  },
  {
    symbol: '₩',
    label: 'South Korean Won',
    symbol_native: '₩',
    decimal_digits: 0,
    rounding: 0,
    value: 'krw',
    name_plural: 'South Korean won'
  },
  {
    symbol: 'MX$',
    label: 'Mexican Peso',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'mxn',
    name_plural: 'Mexican pesos'
  },
  {
    symbol: 'Nkr',
    label: 'Norwegian Krone',
    symbol_native: 'kr',
    decimal_digits: 2,
    rounding: 0,
    value: 'nok',
    name_plural: 'Norwegian kroner'
  },
  {
    symbol: 'NZ$',
    label: 'New Zealand Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'nzd',
    name_plural: 'New Zealand dollars'
  },
  {
    symbol: 'RUB',
    label: 'Russian Ruble',
    symbol_native: 'руб.',
    decimal_digits: 2,
    rounding: 0,
    value: 'rub',
    name_plural: 'Russian rubles'
  },
  {
    symbol: 'Skr',
    label: 'Swedish Krona',
    symbol_native: 'kr',
    decimal_digits: 2,
    rounding: 0,
    value: 'sek',
    name_plural: 'Swedish kronor'
  },
  {
    symbol: 'S$',
    label: 'Singapore Dollar',
    symbol_native: '$',
    decimal_digits: 2,
    rounding: 0,
    value: 'sgd',
    name_plural: 'Singapore dollars'
  },
  {
    symbol: 'TL',
    label: 'Turkish Lira',
    symbol_native: 'TL',
    decimal_digits: 2,
    rounding: 0,
    value: 'try',
    name_plural: 'Turkish Lira'
  },
  {
    symbol: 'R',
    label: 'South African Rand',
    symbol_native: 'R',
    decimal_digits: 2,
    rounding: 0,
    value: 'zar',
    name_plural: 'South African rand'
  },
  {
    symbol: '$',
    label: 'Chilean Peso',
    symbol_native: '$',
    decimal_digits: 0,
    rounding: 0,
    value: 'clp',
    name_plural: 'Chilean Pesos'
  }
];

// Export
// -----------------------------------------------
export default CurrencyDefinitions;
